
// components imports
import { CheckboxInput, DateInput, DropdownInput, ListInput, NumberInput, Switch, TextAreaInput, TextInput, TextWithButtonInput } from "components/Inputs"
import { AutoCompleteAddress, autoCompleteAeroporto } from "services/FormFunctions"

// constant imports
import { TIPO,SUBTIPO } from "constants/tiposDoc"
import { ZonaDoBairro } from "constants/bairrosZona"
import { tipoImovelNome } from "constants/tiposImovel"
import { inputGroupNames } from "constants/inputGroupNames"

// assets imports
import searchIcon from "assets/searchIcon.png"
import listBairrosAju from "json/BairrosAju.json"

const searchImg = <img src={searchIcon} className="mx-1" width="20px" height="20px" alt="ícone"/>

const listaAdeAia = ["Parque ecológico", "Faixa circundante", "Mangue", "A.I.U. 1", "A.I.U. 2", "A.I.U. 3", "A.I.U. 4", "Nenhum"]
const listaMacrozonas = ["ZAP1", "ZAP2", "ZAP3", "ZAP4", "ZAP5", "ZAB1", "ZAB2", "ZAR"]

const listaClassificacaoVias = [
    "Via Arterial",
    "Via Arterial Projetada",
    "Via Coletora",
    "Via Coletora Projetada",
    "Via Contenção Urbana",
    "Via Contenção Urbana Planejada",
    "Via Expressa",
    "Via Expressa Projetada",
    "Via Principal",
    "Via Principal Projetada",
    "Via Local",

]
const listaRespTecTipo = ["Projeto", "Execução da obra", "Levantamento topográfico"]
const listaServicos = ["Construção inicial", "Acréscimo / reforma", "Construção inicial com recuo especial"]

let listaTiposUso =
[
    tipoImovelNome.Uniresidencial,
    tipoImovelNome.MultiresidencialAte4Pav,
    tipoImovelNome.MultiresidencialAcima4Pav,
    tipoImovelNome.NaoResidencial,
    tipoImovelNome.CondominioLotes,
    tipoImovelNome.ERB,
    tipoImovelNome.GLP
]
const listaZonaAeronautica = ["-", "Aeroporto", "Aeródromo"]
const listaZonaProtecao = ["Área horizontal externa", "Área de aproximação", "Aproximação e decolagem", "Área horizontal interna", "Área cônica"]
const listaZonaRuido = ["-", "Área I", "Área II"]

const obs =
{
    altProjArq: "A EMURB não se responsabiliza no caso de alterações do projeto arquitetônico em função de exigências do corpo de bombeiros, " + 
                "dimensões do terreno e outras exigências de outros órgãos públicos.",
    anuencia: "Esta Anuência Prévia não dá o direito de iniciar a construção da edificação. Trata-se somente da aprovação do projeto arquitetônico apresentado.",
    autRepGerais1: "Esta Autorização contempla somente a execução de reparos gerais ao empreendimento, a mesma não regulariza nenhuma "+
                    "alteração que por ventura tenha havido no imóvel, sendo referente exclusivamente aos serviços de reparos gerais.",
    autRepGerais2: "Os serviços de reparos gerais devem ser acompanhados por profissional habilitado.",
    autRepGerais3: "Quando da conclusão dos serviços deverá ser solicitado o atesto de conclusão de reparos gerais.",
    autRepGeraisAcess: "Atendimento aos preceitos da acessibilidade, conforme os padrões da ABNT NBR 9050/2020 e NBR 16537/2016, " +
                        "da Lei Brasileira de Inclusão da Pessoa com Deficiência N° 13.146/2015 e do Decreto N° 5296/2004 que regulamenta " +
                        "a Lei N° 10098/2000 e demais legislações vigentes.",
    certConclServicos: "A Certidão de Conclusão dos serviços só será emitida com a apresentação da " + 
                        "Licença de Operação da Sema e Certificado de Conclusão do Corpo de Bombeiros, " +
                        "conforme o art. 11 da resolução no 04/2008 de 30/09/2008 do Condurb.",
    certRegul1: "Apresentado Laudo de Vistoria sobre ART Nº XXXXXXXXXXXXX atestando condições normais de habitabilidade",
    demolicao: "Caso a demolição interfira no sistema viário cabe procurar a SMTT para as devidas orientações antes de iniciar o serviço;",
    dirDrenagem1: "As diretrizes têm como objetivo orientar os proprietários acerca das exigências mínimas que deverão " +
                    "ser seguidas na elaboração dos projetos de drenagem pluvial, considerando os empreendimentos " +
                    "que futuramente serão implantados na região.",
    dirDrenagem2: "Para o licenciamento, deve ser apresentado um conjunto de alternativas para coletar, aproveitar e " +
                    "dispor das águas pluviais, tais como: valas e/ou trincheiras de infiltração, estacionamentos com pisos " +
                    "permeáveis (grama, brita ou intertravados), tanques de retenção para reúso da água e áreas de " +
                    "amortecimento da drenagem. É necessário fornecer um jogo completo do projeto de drenagem pluvial " +
                    "no formato PDF, que abranja a captação das águas de todos os pavimentos, perfis de todas as vias " +
                    "internas, tubulações, detalhes das caixas de passagem, poços de visita e bocas de lobo, indicando o " +
                    "ponto de lançamento final das águas. Este projeto deve ser assinado pelo projetista e pelo " +
                    "proprietário. Além disso, é preciso anexar um memorial descritivo e planilhas de cálculos. Após a " +
                    "análise e aprovação do projeto pela equipe técnica da EMURB, os documentos deverão ser " +
                    "entregues no formato DWG; Não será permitido nenhum lançamento de águas pluviais para as " +
                    "vias públicas, para o mar ou para terrenos de terceiros",
    dirDrenagem3: "Os levantamentos topográficos (planialtimétricos) devem incluir informações separadas em camadas " +
                    "de acordo com a natureza temática (hidrografia, rodovias, toponímia, cotas, lotes, ruas, meio-fio, etc.) " +
                    "e devem ser georreferenciados pelo Sistema UTM com Datum Horizontal SAD-69 e Meridiano 39 " +
                    "WGr, utilizando como referência a monografia de marcos XXXXX (cópias em anexo)",
    dirDrenagem4: "Não será permitido o lançamento da tubulação pelo eixo da via pública com diâmetros inferiores a " +
                    "400 mm e também execução de caixas e poços de visitas nos passeios públicos",
    dirDrenagem5: "As cotas de implantação do empreendimento devem ser no mínimo, XXXXXXX " +
                    "superiores à cota do eixo existente na XXXXXXX, próxima ao empreendimento",
    dirDrenagem6: "O lançamento do excedente da drenagem pluvial do empreendimento deverá ser direcionado para a " +
                    "boca de lobo mais próxima da rede de drenagem pluvial existente na XXXXXXXX",
    dirDrenagem7: "Deverá ser obedecida a Resolução CONAMA Nº. 303 de 20 de março de 2002, assim como todas as " +
                    "normas vigentes municipais, estaduais e federais relativas aos serviços de Saneamento e Meio Ambiente",
    dirDrenagem8: "A realização de obras de infraestrutura, mesmo aquelas que envolvam pequenas travessias e interfiram " +
                    "no sistema viário já implantado, só poderá ser executada mediante autorização emitida pelo " +
                    "Departamento de Licenciamento de Obras de Infraestrutura da Emurb",

    docAlvara: "Para o protocolo do Alvará de Construção caberá apresentação de documentação específica, " +
                "que inclui cópia desta Anuência Prévia com as plantas aprovadas, bem como o cumprimento do abaixo especificado:" +
                "\n• Projeto arquitetônico legal;" +
                "\n• Certidão de Inteiro Teor atualizada;" +
                "\n• ART/RRT/TRT do responsável técnico pela execução da obra;" +
                "\n• Licença Ambiental válida ou Dispensa de Licença emitida pela Sema;",
    docAlvaraLoteamento: "Para o protocolo do Alvará de Loteamento caberá apresentação de documentação específica, " + 
                            "que inclui cópia desta Anuência Prévia com as plantas aprovadas, bem como o cumprimento do abaixo especificado:" +
                            "\n• Projeto urbanístico completo;" +
                            "\n• Certidão de Inteiro teor atualizada;" +
                            "\n• ART/RRT/TRT do responsável técnico pelo projeto arquitetônico e execução da obra;" +
                            "\n• Memorial Descritivo conforme Instrução Técnica N° 01/2023 da Emurb;" +
                            "\n• Projeto da rede de energia aprovado pela Energisa;" +
                            "\n• Projeto da rede de iluminação pública;" +
                            "\n• Projeto da rede de abastecimento de água aprovado pela Deso;" +
                            "\n• Projeto da rede de sinalização viária aprovado pela SMTT;" +
                            "\n• Projeto da rede de drenagem pluvial completo aprovado pelo DLOI/Emurb;" +
                            "\n• Licença Ambiental válida emitida pela SEMA;" +
                            "\n• Documentos para liberação do Termo de Compromisso autorizativo de registro do loteamento;",
    docERB: "Para o protocolo da Declaração de Conclusão de Instalação de Estação Rádio-Base caberá apresentação de documentação " +
            "específica, que inclui cópia desta Autorização com as plantas aprovadas, bem como o cumprimento do abaixo especificado:" +
            "\n• Atendimento ao projeto arquitetônico aprovado;" +
            "\n• Certidão de Inteiro Teor atualizada;" +
            "\n• Licença emitida pela Anatel;" +
            "\n• Licença Ambiental válida emitida pela SEMA;",
    docsImovelAnuencia: "Documentos obtidos para fins de obtenção de Anuência Prévia:" + 
                        "\n 1. XXXXX" +
                        "\n 2. XXXXX",
    docsImovelAlvara: "Documentos obtidos para fins de obtenção do Alvará de Construção:" + 
                        "\n 1. XXXXX" +
                        "\n 2. XXXXX",
    emsurb: "Procurar a Emsurb para orientação quanto ao adequado manejo e transporte de resíduos sólidos da Construção (Resolução Conama N° 307/2002).",
    ERBCondicionantes: "A Emurb poderá modificar os condicionantes e as medidas de controle e adequação, " +
                        "suspender ou cancelar a presente licença, quando ocorrer:" +
                        "\n• Violação ou inadequação de quaisquer condicionantes ou normas legais;" +
                        "\n• Omissão ou falsa descrição de informações relevantes que subsidiaram a expedição desta autorização.",
    loteamento: "Somente após o registro do loteamento é permitido ou prometido vender a parcela do loteamento (art. 37 da lei federal no. 6.766/79).",
    habiteseUnires: "Para o protocolo de Habite-se caberá apresentação de documentação específica, " + 
                            "que inclui cópia deste Alvará de Construção com as plantas aprovadas, bem como o cumprimento do abaixo especificado: " +
                            "\n• Atendimento ao projeto arquitetônico aprovado;" +
                            "\n• Certidão de Inteiro Teor atualizada;" +
                            "\n• Memorial Descritivo conforme Instrução Técnica N° 01/2023 da EMURB;",
    habiteseZAR: "Processo de Habite-se será enviado a coordenadoria para ser " +
                    "submetido à análise do Jurídico/Emurb podendo ser submetido à justiça enquanto não houver " +
                    "total execução das obras e serviços pertinentes a macrodrenagem da Zona de Expansão/Jabotiana.",
    naoAtendimento: "O não atendimento às prescrições regulamentares acima, constituirá infração urbanística, " +
                        "punível com multa do dobro do valor da taxa da licença, sem prejuizo das medidas administrativas ou judiciais " + 
                        "(art. 221 Lei N° 1547/1989 alterada pela Lei Complementar N° 17/1995), podendo, inclusive, resultar no cancelamento do presente alvará.",
    obrasInfra1: "É de responsabilidade exclusiva do requerente a adoção de todas as providências para levantamento de informações e a " +
                    "realização de estudos da interferência das obras autorizadas com instalações de outras concessionárias de serviços púbicos, tais " +
                    "como, mas não exclusivamente, Deso, Energisa, empresas de telefonia, empresas de serviço de internet, rede de drenagem pública;",
    obrasInfra2: "Quaisquer danos às redes existentes (inclusive de água, esgoto, gás, energia, telefonia e drenagem), " + 
                    "calçadas, sinalização horizontal/vertical, paisagismo, canteiro ou qualquer tipo de área verde serão saneados pela contratada, " +
                    "isentando a Emurb de quaisquer responsabilidades;",
    obrasInfra3: "Cabe cumprir a especificação pertinente a abertura e fechamento de vala (anexa), até a colocação da base, ressalvando- " +
                    "se o disposto no item (10°): “após 60 (sessenta) dias de estabilização da vala, caso haja recalque, será aplicada uma pintura " +
                    "de ligação com emulsão rl-1c na taxa de 1,0 l/m² (um litro por metro quadrado), para aplicação de C.B.U.Q. Na espessura " +
                    "necessária a fim de corrigir os recalques provenientes da acomodaçâo dos materiais da referida vala”, à custa da requerente;",
    obrasInfra4: "A obra deverá estar devidamente identificada através da placa de obra, de acordo com a Lei 5194/66 artigo 16, contendo " +
                    "o nome da empresa requerente, da empresa executora, o número da licença emitida pela emurb, o prazo de execução do " +
                    "serviço bem como o número da ART de execução e o nome do responsável técnico com seu respectivo número do CREA/CAU;",
    obrasInfra5: "De acordo com o Ofício Nº 555/2024 GAB-DPS/SMTT foi aprovado o projeto de sinalização apresentado pela empresa e a " +
                    "autorização para interdição das vias deverá ser solicitada em no mínimo 10 dias úteis antes do início das obras;",
    obrasInfra6: "A Diretoria de Urbanismo da Emurb deverá ser oficializada da conclusão dos serviços, inclusive da recomposição da " +
                    "pavimentação e sinalização horizontal, cabendo apresentação da locação definitiva do ramal, em meio digital, tomando como " +
                    "referência a monografia oficial de marcos da PMA, à disposição no Departamento de Licenciamentode Obras de Infraestrutura " +
                    "(DLOI)/Coordenadoria de Urbanismo (Courb);",
    obrasInfra7: "A obra não poderá causar qualquer dano ao pavimento da via, sendo ela executada exclusivamente no canteiro da avenida;",
    obrasInfra8: "A não realização dos serviços no prazo aprovado obrigará à XXXXXX informar nova programação à Diretoria de Urbanismo da " +
                    "Emurb e SMTT para emissão de autorização cabível, que obedecerá ao prazo da licença;",
    obrasInfra9: "A autorização da obra no canteiro deve ser solicitada na Emsurb;",
    obrasInfra10: "A não obediência às prescrições regulamentares acima constituirá infração urbanística punível, com multa, sem prejuízo " +
                    "de medidas administrativas ou judiciais (inciso II art. 221 da Lei 1547/89 alteradas pela lei complementar 017/95).",
    prazoMaximoRegistroLoteamento: "Prazo máximo para registro do loteamento de XXXXXXXX , a contar da data do termo de compromisso firmado, " + 
                                    "sob pena de caducidade da aprovação do projeto (art. 18 da lei federal 6766/79 modificada pela lei 9.785/99).",
    registroLoteamento: "Somente após o registro do loteamento é permitido vender ou prometer vender a parcela do loteamento "+
                        "(art. 37 da lei federal no. 6.766/79).",
    sistemaViario: "As intervenções no sistema viário (interligações à rede pública) deverão ser precedidas da Autorização de Obras de Infraestrutura emitida pela DLOI/DIURB/EMURB.",
    taxaOcupMenor30: "No caso de substituição de projeto que torne a taxa de ocupação superior a 30%, será aplicada a taxa integral da licença",
    termoCompromisso: "Emitido Termo de Compromisso N° XXXXXX em XXXXXXX autorizando registro do parcelamento, " + 
                        "que deverá ser integralmente atendido pelo cartório competente no tocante às garantias e averbação de áreas públicas " + 
                        "(§ único art. 20 e art. 22 lei federal 6766/79 modificada pela lei 9.785/99).",
    termoDemarc: "A presente certidão é o reconhecimento da ocupação do imóvel através de " +
                    "elementos físicos que delimitam a área ocupada e não dá direito à posse do terreno, " +
                    "devendo o cartório de registro agir de acordo com a Lei de registro n° 6.015/73, ficando a Emurb/P.M.A. " +
                    "isenta de qualquer responsabilidade se as respectivas medidas não forem aceitas pelos confrontantes.",
    termoVerObras: "Atestamos para os devidos fins que foram concluídas as obras de infraestrutura do loteamento XXXXX, " +
                    "Bairro XXXXX, licenciada sob alvará n° XX/XXXX - DPS, partido urbanístico aprovado e termo de compromisso n°XX/XXXX em XX/XX/XXXX (Processo XX.XXX/XXXX) " + 
                    "e registrado no cartório do X° ofísico - Xa circunscrição." + 
                    "\nParcelamento constituído de XXXXX de acordo com planta e memorial descritivo aprovados" + 
                    "\nTodos os lotes foram demarcados e as vias públicas implantadas, conforme projeto aprovado em XX/XXXX. O empreendimento possui XXXXX." + 
                    "\nO parcelamento obteve licença de operação da SEMA, possui rede de abastecimento de água atestada pela DESO, de energia pela ENERGISA, de iluminação pública e de drenagem pluvial pela EMURB" + 
                    "\nPelo presente Termo de Verificação, ficam liberados: XXXXX",
    usoOcupSolo1: "O licenciamento deverá atender:" +
                    "\n• Normas e índices de ocupação do solo;" +
                    "\n• Taxa de ocupação máxima (lei complementar 042/2000);" +
                    "\n• Taxa de permeabilidade mínima (lei complementar 042/2000);" +
                    "\n• Recuos mínimos frontais (lei complementar 042/2000);" +
                    "\n• Coeficiente de aproveitamento (lei complementar 042/2000);" +
                    "\n• Número máximo de pavimentos (lei complementar 042/2000);" +
                    "\n• Quantidade de vagas de estacionamento (lei complementar 042/2000);" +
                    "\n• Rampas no recuo frontal (lei complementar 043/2000).",
    usoOcupSolo2: "Exigências para protocolo de licenciamento:" +
                    "\n• Elaboração do projeto da edificação atendendo as normas/parâmetros aplicáveis disponíveis na Instrução Técnica N° 01/2023 " +
                    "da EMURB e as orientações, exigências e restrições, neste especificadas." +
                    "\n• Atendimento aos preceitos da acessibilidade, conforme os padrões da ABNT NBR 9050/2020 e NBR 16537/2016, da Lei " +
                    "Brasileira de Inclusão da Pessoa com Deficiência N° 13.146/2015 e do Decreto N° 5296/2004 que regulamenta a Lei N° " +
                    "10098/2000 e demais legislações vigentes.",
    usoOcupSolo3: "Apresentação de documentos e plantas (projeto arquitetônico legal) conforme relação padronizada disponível na " +
                    "Instrução Técnica N° 01/2023 da EMURB para cada tipo de serviço.",
    usoOcupSolo4: "Qualquer intervenção (abertura de valas, rompimento de pavimentação) no sistema viário deverá ser precedida de " + 
                    "autorização da EMURB/DIURB.",
    usoOcupSolo5: "Certidão emitda para fins de licenciamento ambiental."
}

const certifico =
{
    CertDemol: (subTipoDoc) => { return getCertifico(TIPO.CertDemol, subTipoDoc, undefined, undefined) },
    CertRegul: (subTipoDoc) => { return getCertifico(TIPO.CertRegul, subTipoDoc, undefined, undefined) }
}

export function getCertifico(tipoDoc, subTipoDoc, docData, tipoImovel)
{
    if (tipoDoc !== TIPO.CertRegul && tipoDoc !== TIPO.CertDemol) { return {}}

    if (tipoDoc === TIPO.CertDemol)
    {
        return "**Certifico para os devidos fins que**\n\n O imóvel situado na XXXXX, Cartório do X° Ofício da Comarca de Aracaju " +
                " - 2ᵃ circunscrição imobiliária - Livro N° XX - Registro Geral - Matrícula XXX.XXX encontra-se demolido"
    }


    if (subTipoDoc === SUBTIPO.Loteamento)
    {
        return "**Certifico para os devidos fins que**\n\n foi regularizado o parcelamento em forma de loteamento situado na XXXXX " +
                "Bairro XXXXX, resultando em XX lotes e áreas públicas (vias e 01 área verde), conforme quadro acima, e partido urbanístico " +
                "(prancha XX/XX) anexo, atendendo ao Plano Diretor - Lei Complementar 042/2000 (Art. 185/Art. 192/Art. 195) e à lei federal 5766/79." + 
                "\nAs vias públicas foram implantadas conforme projeto regularizado, totalizando XXXXX m² e com pavimentação XXXXX. " + 
                "O loteamento possui rede de abastecimento de água atestada pela DESO, rede de energia comprovada pela Energisa, declaração de " +
                "iluminação pública plea Emurb, rede de drenagem pela Emurb e parecer técnico da SEMA." + 
                "\nO projeto regularizado deverá ser registrado no Cartório de Registro de Imóveis competente, dentro do prazo máximo de 60 (sessenta) dias " +
                "(prazo determinado no Art. 186 do Plano Diretor para registro de parcelamento aprovado)." + 
                "\nCaberá ao cartório fazer o registro do loteamento e averbação da abertura das vias e área verde " +
                "que desde a data do registro, passará a integrar o domínio do município (Art. 20 e 22 da lei federal 6766/79, alterada pela lei 9785/99)"
    }
    
    let message = ""

    const introText = "Existe uma edificação conforme a Legislação Urbanistica em vigor, beneficiada pela lei Complementar 165/2017, situada à "
    const complementoText = docData?.complemento ? ", " + docData.complemento : ", XXXXX"
    const loteText = docData?.numLote ? ", Lote " + docData.numLote : ", Lote XXXXX"
    const quadraText = docData?.numQuadra ? ", Quadra " + docData.numQuadra : ", Quadra XXXXX"
    const enderecoText = (docData?.logradouro ?? "XXXXX") + ", n° " + (docData?.numPorta ?? "XXXXX") + complementoText + loteText + quadraText + ", Bairro " + (docData?.bairro ?? "XXXXX")
    //   const numPav = countItemsInGroupFields(docData, "pavimento")
    const numPav = 1
    const edificacaoText = ", de uso " + (tipoImovel ?? "XXXXX") + ", " + (Number(numPav) <= 1 ? "térrea" : "de " + numPav + " pavimentos")
    const areaText = ", com área construída de " + (docData?.areaConstruida ?? "XXXXX") + " m²"
    const descricaoEdificacaoText = ", constando os seguintes compartimentos: "

    message += "\n"
    message += "**CERTIFICO PARA OS DEVIDOS FINS QUE:**"
    message += "\n\n"
    message += introText + enderecoText + edificacaoText + areaText + descricaoEdificacaoText
    for (let i = 0 ; i <= numPav - 1; i += 1)
    {
        const qtdPav = (docData?.["pavimentosQuantidade" + i] ?? "XXXXX")
        const pavimentoText = qtdPav === "1" ? qtdPav + " pavimento " : qtdPav + " pavimentos "
        const classificacaoText = (docData?.["pavimentosClassificacao" + i].toLowerCase() ?? "XXXXX") + (2 <= Number(qtdPav) ? "es" : "")
        const areaConstText = ", com área construída de " + (docData?.["pavimentosAreaConstruida" + i] ?? "XXXXX") + " m²"
        const descricaoText = ", contendo: " + (docData?.["pavimentosDescricaoAmbientes" + i] ?? "XXXXX")
        message += pavimentoText + classificacaoText + areaConstText + descricaoText
    }
    message += "\n\n"
    message += "Os termos acima deverão ser transcritos na íntegra pelo Cartório de Registros."
    message += "\n"

    return message
}

export function obsDocumento(tipoDoc, subTipoDoc)
{
    switch (tipoDoc)
    {
        case TIPO.Alvara:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:
                    return [
                        obs.habiteseUnires,
                        obs.naoAtendimento,
                        obs.emsurb,
                        obs.docsImovelAlvara, // apenas se existirem
                        obs.habiteseZAR, // apenas na ZAR
                        obs.taxaOcupMenor30 // apenas se taxaOcup < 30
                    ]
                    
                case SUBTIPO.MultiresidencialAte4Pav:
                case SUBTIPO.MultiresidencialAcima4Pav:
                case SUBTIPO.NaoResidencial:
                    return [
                        obs.habiteseUnires,
                        obs.naoAtendimento,
                        obs.sistemaViario,
                        obs.docsImovelAlvara // apenas se existirem
                    ]
            
                case SUBTIPO.Loteamento:
                    return [
                        obs.termoVerObras,
                        obs.termoVerObras2,
                        obs.sistemaViario,
                        obs.emsurb,
                        obs.docsImovelAlvara, // apenas se existirem
                        obs.prazoMaximoRegistroLoteamento,
                        obs.termoCompromisso,
                        obs.loteamento
                    ]
                    
                default: console.log("Erro: Tentando gerar obs de Alvará sem subtipo válido") ; return
            }
           
        case TIPO.Anuencia:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:   
                case SUBTIPO.MultiresidencialAte4Pav:
                case SUBTIPO.MultiresidencialAcima4Pav:
                case SUBTIPO.NaoResidencial:
                    return [
                        obs.anuencia,
                        obs.altProjArq,
                        obs.docAlvara,
                        obs.docsImovelAnuencia
                    ]
            
                case SUBTIPO.Loteamento:
                    return [
                        obs.anuencia,
                        obs.altProjArq,
                        obs.docAlvaraLoteamento,
                        obs.docsImovelAnuencia,
                        obs.registroLoteamento
                    ]
                    
                default: console.log("Erro: Tentando gerar obs de Anuência sem subtipo válido") ; return
            }

        case TIPO.DirDrenagem:

        return [
            obs.dirDrenagem1,
            obs.dirDrenagem2,
            obs.dirDrenagem3,
            obs.dirDrenagem4,
            obs.dirDrenagem5,
            obs.dirDrenagem6,
            obs.dirDrenagem7,
            obs.dirDrenagem8
        ]

        case TIPO.AutDemol:

        return [
            obs.emsurb,
            obs.demolicao,
            obs.docsImovelAnuencia
        ]
        
        case TIPO.AutERB:

        return [
            obs.docERB,
            obs.certConclServicos,
            obs.ERBCondicionantes,
            obs.sistemaViario,
            obs.docsImovelAnuencia
        ]
        
        case TIPO.AutObrasInfra:

        return [
            obs.obrasInfra5,
            obs.obrasInfra1,
            obs.obrasInfra2,
            obs.obrasInfra3,
            obs.obrasInfra4,
            obs.obrasInfra6,
            obs.obrasInfra7,
            obs.obrasInfra8,
            obs.obrasInfra10
        ]
        
        case TIPO.AutRepGerais:

        return [
            obs.emsurb,
            obs.autRepGerais1,
            obs.autRepGerais2,
            obs.autRepGerais3
        ]
        
        case TIPO.AutRepGeraisAcess:

        return [
            obs.emsurb,
            obs.autRepGerais1,
            obs.autRepGerais2,
            obs.autRepGerais3,
            obs.autRepGeraisAcess
        ]

        case TIPO.CertDemol:
            return [
            ]

        
        case TIPO.CertRegul:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:   
                case SUBTIPO.MultiresidencialAte4Pav:
                case SUBTIPO.MultiresidencialAcima4Pav:
                case SUBTIPO.NaoResidencial:
                    return [
                        obs.certRegul1
                    ]
    
                case SUBTIPO.Loteamento:
                    return [
                        obs.certRegulLoteamento
                    ]
    
                default: console.log("Erro: Tentando gerar obs de CertRegul sem subtipo válido") ; return
            }

        case TIPO.CertRegulInfra:

        return [
            obs.obrasInfra5,
            obs.obrasInfra1,
            obs.obrasInfra2,
            obs.obrasInfra3,
            obs.obrasInfra4,
            obs.obrasInfra6,
            obs.obrasInfra7,
            obs.obrasInfra8,
            obs.obrasInfra9,
            obs.obrasInfra10
        ]
        
        case TIPO.CertUsoOcupSolo:

        return [
            obs.usoOcupSolo1,
            obs.usoOcupSolo2,
            obs.usoOcupSolo3,
            obs.usoOcupSolo4,
            obs.usoOcupSolo5
        ]
        
        case TIPO.CertUsoOcupSoloDir:

        return [
        ]
        
        case TIPO.TermoDemarc:

        return [
            obs.termoDemarc
        ]
        
        case TIPO.TermoDesmGleba:
        case TIPO.TermoDesmLote:
        case TIPO.TermoRem:
        case TIPO.TermoRemDesm:

        return [
        ]

        case TIPO.CertLaudoVist:
        case TIPO.DeclAtendTermoCompr:
        case TIPO.DeclConcObrasInfra:
        case TIPO.DeclGLP:
        case TIPO.DeclInstERB:
        case TIPO.DeclNumeroPorta:
        case TIPO.DeclRepGerais:
        case TIPO.DeclRepGeraisAcess:                
            return

        case TIPO.TermoVerObras:                
            return [
                obs.termoVerObras
            ]

        default: console.log("Aviso: Tentando gerar obs de documento sem tipo válido") ; return
    }
}

export function notasDocumento(tipoDoc)
{
  switch (tipoDoc)
  {
    case TIPO.CertLaudoVist:
    
    return "\nCertificamos para os devidos fins que o empreendimento apresentou LAUDO DE VISTORIA TÉCNICA " +
            "das condições de conservação da edificação, em atendimento à Lei Municipal nº. 2.765/99, " +
            "atestando que a edificação não necessita de serviços de manutenção descriminados no referido Laudo de Vistoria Técnica." +
            "\nCabe apresentação de novo Laudo de Vistoria Técnica após 5 (cinco) anos a partir desta data (Art. 1º Lei nº.2765/99).\n"  
    
    case TIPO.DeclAtendTermoCompr:

    return "\nDeclaramos para os devidos fins que as pendências descritas no Termo de Compromisso supracitado "+
            "foram executadas conforme vistoria realizada em XX/XX/XXXX.\n"
    
    case TIPO.DeclConcObrasInfra:
    
    return "\nPELA PRESENTE DECLARAÇÃO FICA ATESTADA A CONCLUSÃO DAS INTERVENÇÕES DESCRITAS DE ACORDO COM A RESOLUÇÃO N° 04/2007 DO CONSELHO " +
            "MUNICIPAL DE DESENVOLVIMENTO URBANO E AMBIENTAL. " +
            "\nNotas:" +
            "\n- A Emurb não se responsabiliza por quaisquer danos, porventura, "+
            " causados em possíveis redes existentes de drenagem de águas pluviais, telefonia ou esgoto\n"

    case TIPO.DeclGLP:
        
    return "\nDeclaramos para fins exclusivos de análise de Alvará de Funcionamento pela Secretaria " +
            "Municipal da Fazenda que no imóvel supracitado funciona a REVENDA DE GÁS LIQUEFEITO DE PETRÓLEO (GLP)." +
            "\nNotas:" +
            "\n- O empreendimento atende as Leis Municipais de nº 2524/1997 e nº 4938/2017.\n"

    case TIPO.DeclInstERB:
        
    return "\nComo responsável técnico pela execução do projeto e instalação da Estação de Rádio-Base - ERB declaro:" +
            "\n1. Sob as penas da lei, que a referida Estação de Rádio-Base – ERB atende todas as disposições " +
            "exigidas pela legislação federal e municipal, em especial à Lei n° 13.116 de 20 de abril de 2015, e " +
            "à Lei n° 5.547 de 22 de dezembro de 2022." +
            "\n2. Estar ciente de que, caso seja constatado, a qualquer momento, desconformidade em relação aos " +
            "parâmetros legais determinados por lei federal ou municipal específica, a Estação de Rádio-Base - " +
            "ERB terá sua licença revogada, devendo ser desinstalada, ficando sujeita às penalidades aplicáveis." +
            "\n3. A veracidade das informações prestadas, estando sujeito a responder civil, criminal e " +
            "administrativamente caso seja constatado descumprimento das leis supracitadas e/ou " +
            "fornecimento de informações inverídicas." +
            "\nO declarante responde, civil e penalmente, pela veracidade das declarações ora prestadas e assume " +
            "todas as obrigações previstas na legislação pertinente vigente, inclusive eventuais danos causados a " +
            "terceiros, isentando a Prefeitura Municipal de Aracaju de quaisquer responsabilidades pela mesma.\n"

    case TIPO.DeclNumeroPorta:
        
    return "\nDeclaramos, para fins de tramitação em Secretarias e Órgãos Públicos e Privados, que o imóvel em questão tem como número de porta: XXXXXX" +
        "\nNotas:" +
        "\n- Proibida a averbação no registro imobiliário para qualquer fim de direito;" +
        "\n- A fixação do número de porta não equivale a Habite-se, a regularização e nem autoriza ou atesta a habitabilidade do imóvel;" +
        "\n- Edificação com uso multiresidencial, cabendo a Semfaz efetuar a devida alteração.\n"

    case TIPO.DeclRepGerais:
        
    return "\nDeclaramos para os devidos fins que os serviços de reparos gerais foram executados de " +
        "acordo com o solicitado na Autorização de Reparos Gerais supracitada, e conforme vistoria realizada em XX/XX/XXXX" +
        "\nNotas:" +
        "\n- Documento emitido apenas para declarar a Conclusão dos Reparos Gerais, sem fins de averbação\n"

    case TIPO.DeclRepGeraisAcess:
        
    return "\nDeclaramos para os devidos fins que os serviços de reparos gerais de acessibilidade foram " +
        "executados de acordo com o solicitado na Autorização de Reparos Gerais de Acessibilidade supracitada, e " +
        "conforme vistoria realizada em XX/XX/XXXX" +
        "\nNotas:" +
        "\n- Documento emitido apenas para declarar a Conclusão dos Reparos Gerais de Acessibilidade, sem fins de averbação.\n"

    default: console.log("Aviso: Tentando gerar notas de documento sem campo notas") ; return
  }
}

async function AutoCompleteAddressRequerente()
{
    return await AutoCompleteAddress("cep", "bairro", "complemento", "logradouro")
}

async function AutoCompleteAddressObra()
{
    return await AutoCompleteAddress("cepObra", "bairroObra", "complementoObra", "logradouroObra")
}

function AutoCompleteZona()
{
    const bairro = document.getElementsByName("bairro")[0].value
    if(bairro)
    {
        const zonaDoBairro = ZonaDoBairro(bairro)
        if(document.getElementsByName("macrozoneamento")[0])
            document.getElementsByName("macrozoneamento")[0].value = zonaDoBairro ? zonaDoBairro : "Zona"
    }
}

// TODO remover
function warnValidateProprietario(value)
{
    if (value === "oi2") { return "oi"}
}

function HabilitarDesabilitarNumDoc()
{
    const numDocField = document.getElementsByName("numDoc")[0]
    numDocField.disabled = !numDocField.disabled
}

export const docField =
{
    anoProc: () => { return <TextInput Name={"anoProc"} Placeholder={"0000"} Label={"Ano do processo"} MaxLength={10} /> },
    areaRemanescente: () => { return <TextInput Name={"areaRemanescente"} Placeholder={"0.00 m²"} Label={"Descrição da área remanescente conforme planta aprovada"} MaxLength={100} /> },
    atividade: () => { return <TextInput Name={"atividade"} Label={"Atividade"} MaxLength={100} /> },
    autoNumerar: () => { return <Switch Name={"autoNumerar"} Label={"Numeração automática"} DefaultChecked={false} OnChange={HabilitarDesabilitarNumDoc} /> },
    cartorioZonaImob: () => { return <TextInput Name={"cartorioZonaImob"} Label={"Cartório/Zona imobiliária"} MaxLength={50} /> },
    classificacaoUso: () => { return <TextInput Name={"classificacaoUso"} Label={"Classificação de uso"} MaxLength={50} /> },
    classificacaoViaria: () => { return <TextInput Name={"classificacaoViaria"} Label={"Classificação viária"} MaxLength={50} /> },
    complemento: () => { return <TextInput Name={"complemento"} Label={"Complemento"} MaxLength={50} /> },
    complementoObra: () => { return <TextInput Name={"complementoObra"} Label={"Complemento"} MaxLength={50} /> },
    contratada: () => { return <TextInput Name={"contratada"} Label={"Contratada"} MaxLength={100} /> },
    contratante: () => { return <TextInput Name={"contratante"} Label={"Contratante"} MaxLength={100} /> },
    cotaMinima: () => { return <TextInput Name={"cotaMinima"} Placeholder={"0,00"} Label={"Cota mínima"} MaxLength={100} /> },
    cpfCnpjContratante: () => { return <TextInput Name={"cpfCnpjContratante"} Placeholder={"000.000.000-00"} Label={"CPF / CNPJ"} MaxLength={14} /> },
    cpfCnpjProprietario: () => { return <TextInput Name={"cpfCnpjProprietario"} Placeholder={"000.000.000-00"} Label={"CPF / CNPJ"} MaxLength={14} /> },
    cpfCnpjRequerente: () => { return <TextInput Name={"cpfCnpjRequerente"} Placeholder={"000.000.000-00"} Label={"CPF / CNPJ"} MaxLength={14} /> },
    cpfCnpjContratada: () => { return <TextInput Name={"cpfCnpjContratada"} Placeholder={"000.000.000-00"} Label={"CPF / CNPJ"} MaxLength={14} /> },
    crea_cauRespTecExec: () => { return <TextInput Name={"crea_cauRespTecExec"} Label={"CREA/CAU"} MaxLength={25} /> },
    crea_cauRespTecProj: () => { return <TextInput Name={"crea_cauRespTecProj"} Label={"CREA/CAU"} MaxLength={25} /> },
    descricaoVagas: () => { return <TextInput Name={"descricaoVagas"} Label={"Descrição das vagas"} MaxLength={100} MinWidth={"685px"} /> },
    divisaoFiscalizacaoPostMun: () => { return <TextInput Name={"divisaoFiscalizacaoPostMun"} Label={"Divisão de fiscalização de posturas municipais"} MaxLength={100} /> },
    divisaoParcelamentoSolo: () => { return <TextInput Name={"divisaoParcelamentoSolo"} Label={"Divisão de parcelamento do solo"} MaxLength={100} /> },
    eixoNomeRua: () => { return <TextInput Name={"eixoNomeRua"} Placeholder={"Avenida tal"} Label={"Nome da rua do eixo existente"} /> }, 
    enderecoContratante: () => { return <TextInput Name={"enderecoContratante"} Label={"Endereço"} MaxLength={100} MinWidth={"685px"} /> },
    finalidade: () => { return <TextInput Name={"finalidade"} Label={"Finalidade"} MaxLength={50} /> },
    infraestruturaLocal: () => { return <TextInput Name={"infraestruturaLocal"} Label={"Infraestrutura local"} MaxLength={50} /> },
    inscCadastral: () => { return <TextInput Name={"inscCadastral"} Placeholder={"00.00.000.0000.00.000"} Label={"Inscrição cadastral"} MaxLength={16} Mask={"99.99.999.9999.99.999"} /> },
    localBocaDeLoboMaisProxima: () => { return <TextInput Name={"localBocaDeLoboMaisProxima"} Placeholder={"Rua tal, esquina com rua tal"} Label={"Local da boca de lobo mais próxima"} /> },
    logradouro: () => { return <TextInput Name={"logradouro"} Placeholder={"Rua das Palmeiras"} Label={"Endereço"} MaxLength={50} /> },
    logradouroObra: () => { return <TextInput Name={"logradouroObra"} Placeholder={"Rua das Palmeiras"} Label={"Endereço"} MaxLength={50} /> },
    loteamento: () => { return <TextInput Name={"loteamento"} Label={"Loteamento"} MaxLength={50} /> },
    loteamentoObra: () => { return <TextInput Name={"loteamentoObra"} Label={"Loteamento"} MaxLength={50} /> },
    matriculaRegistro: () => { return <TextInput Name={"matriculaRegistro"} Placeholder={"00"} Label={"Registros / matrículas"} MaxLength={100} /> },
    memorialDescritivo: () => { return <TextInput Name={"memorialDescritivo"} Label={"Memorial descritivo"} MaxLength={50} /> },
    nomeEmpreendimento: () => { return <TextInput Name={"nomeEmpreendimento"} Label={"Nome do empreendimento"} MaxLength={100} /> },
    nomeProprietario: () => { return <TextInput Name={"nomeProprietario"} Placeholder={"Fulano da Silva"} Label={"Nome do proprietário"} MaxLength={100} MinWidth={"425px"} WarnValidate={warnValidateProprietario} /> },
    nomeRequerente: () => { return <TextInput Name={"nomeRequerente"} Placeholder={"Fulano da Silva"} Label={"Nome do requerente"} MaxLength={100} /> },
    nomeRespTecExec: () => { return <TextInput Name={"nomeRespTecExec"} Placeholder={"Fulano da Silva"} Label={"Nome"} MaxLength={50} /> },
    nomeRespTecProj: () => { return <TextInput Name={"nomeRespTecProj"} Placeholder={"Fulano da Silva"} Label={"Nome"} MaxLength={50} /> },
    numDoc: () => { return <TextInput Name={"numDoc"} Placeholder={"0000"} Label={"N° do documento"} Req={true} MaxLength={10} />},
    numLote: () => { return <TextInput Name={"numLote"} Placeholder={"00"} Label={"N° de lote"} MaxLength={25} /> },
    numLoteObra: () => { return <TextInput Name={"numLoteObra"} Placeholder={"00"} Label={"N° de lote"} MaxLength={25} /> },
    numPorta: () => { return <TextInput Name={"numPorta"} Placeholder={"000"} Label={"N° de porta"} MaxLength={5} /> },
    numPortaObra: () => { return <TextInput Name={"numPortaObra"} Placeholder={"000"} Label={"N° de porta"} MaxLength={5} /> },
    numProc: () => { return <TextInput Name={"numProc"} Placeholder={"00.000"} Label={"N° do processo"} MaxLength={10} /> },
    numQuadra: () => { return <TextInput Name={"numQuadra"} Placeholder={"00"} Label={"N° de quadra"} MaxLength={25} /> },
    numQuadraObra: () => { return <TextInput Name={"numQuadraObra"} Placeholder={"00"} Label={"N° de quadra"} MaxLength={25} /> },
    paisagemNotavel: () => { return <TextInput Name={"paisagemNotavel"} Placeholder={"PN 00"} Label={"Paisagem notável"} MaxLength={25} /> },
    prazoExecServicos: () => { return <TextInput Name={"prazoExecServicos"} Label={"Prazo para a realização dos serviços"} Value={"90 dias corridos a partir da data de emissão"} MinWidth={"425px"} /> },
    registroAutRepGerais: () => { return <TextInput Name={"registroAutRepGerais"} Label={"N° da Autorização de Reparos Gerais"} MaxLength={12} /> },
    registroProcesso: () => { return <TextInput Name={"registroProcesso"} Label={"N° do processo"} MaxLength={12} /> },
    superintUniaoSE: () => { return <TextInput Name={"superintUniaoSE"} Label={"Superintendência da União em Sergipe (SPU/SE)"} MaxLength={50} /> },
    tipoDeObra: () => { return <TextInput Name={"tipoDeObra"} Label={"Tipo de obra"} MaxLength={50} /> },
    tipoServico: () => { return <TextInput Name={"tipoServico"} Label={"Tipo de serviço"} MaxLength={50} /> },
    usosIncomodos: () => { return <TextInput Name={"usosIncomodos"} Label={"Usos incômodos"} MaxLength={50} /> },
    vizinhanca: () => { return <TextInput Name={"vizinhanca"} Label={"Vizinhança"} MaxLength={50} /> },

    areaAcrescida: () => { return <NumberInput Name={"areaAcrescida"} Placeholder={"0.00 m²"} Label={"Área de acréscimo"} /> },
    areaAverbada: () => { return <NumberInput Name={"areaAverbada"} Placeholder={"0.00 m²"} Label={"Área averbada"} /> },
    areaComputavel: () => { return <NumberInput Name={"areaComputavel"} Placeholder={"0.00 m²"} Label={"Área computável"} /> },
    areaConstruida: () => { return <NumberInput Name={"areaConstruida"} Placeholder={"0.00 m²"} Label={"Área construída"} /> },
    areaDemolir: () => { return <NumberInput Name={"areaDemolir"} Placeholder={"0.00 m²"} Label={"Área a demolir"} /> },
    areaLagoa: () => { return <NumberInput Name={"areaLagoa"} Placeholder={"0.00 m²"} Label={"Área de lagoa"} /> },
    areaLiquida: () => { return <NumberInput Name={"areaLiquida"} Placeholder={"0.00 m²"} Label={"Área líquida"} /> },
    areaLotes: () => { return <NumberInput Name={"areaLotes"} Placeholder={"0.00 m²"} Label={"Área dos lotes"} /> },
    areaPermeavel: () => { return <NumberInput Name={"areaPermeavel"} Placeholder={"0.00 m²"} Label={"Área permeável"} /> },
    areaReforma: () => { return <NumberInput Name={"areaReforma"} Placeholder={"0.00 m²"} Label={"Área de reforma"} /> },
    areaRegularizar: () => { return <NumberInput Name={"areaRegularizar"} Placeholder={"0.00 m²"} Label={"Área a regularizar"} /> },
    areaTerreno: () => { return <NumberInput Name={"areaTerreno"} Placeholder={"0.00 m²"} Label={"Área do terreno"} Min={1} /> },
    areaTotal: () => { return <NumberInput Name={"areaTotal"} Placeholder={"0.00 m²"} Label={"Área total"} /> },
    areaTotalDemarcada: () => { return <NumberInput Name={"areaTotalDemarcada"} Placeholder={"0.00 m²"} Label={"Área total demarcada"} /> },
    areaVerde: () => { return <NumberInput Name={"areaVerde"} Placeholder={"0.00 m²"} Label={"Área verde"} /> },
    areaVia: () => { return <NumberInput Name={"areaVia"} Placeholder={"0.00 m²"} Label={"Area non aedificanti"} /> },
    blocos: () => { return <NumberInput Name={"blocos"} Placeholder={"0.00 m²"} Label={"Blocos"} /> },
    gabaritoAltura: () => { return <NumberInput Name={"gabaritoAltura"} Placeholder={"0.00 m"} Label={"Gabarito de altura"} /> },
    numElevadores: () => { return <NumberInput Name={"numElevadores"} Placeholder={"0"} Label={"N° de elevadores"} /> },
    numPav: () => { return <NumberInput Name={"numPav"} Placeholder={"0"} Label={"N° de pavimentos"} /> },
    numeroPlataformas: () => { return <NumberInput Name={"numeroPlataformas"} Placeholder={"0"} Label={"N° de plataformas"} /> },
    qtdLotes: () => { return <NumberInput Name={"qtdLotes"} Placeholder={"0"} Label={"Quantidade de lotes"} /> },
    sistViario: () => { return <NumberInput Name={"sistViario"} Placeholder={"0.00 m²"} Label={"Sistema viário"} /> },
    taxaTotal: () => { return <NumberInput Name={"taxaTotal"} Placeholder={"R$ 0,00"} Label={"Taxa total"} /> },
    unidades: () => { return <NumberInput Name={"unidades"} Placeholder={"0.00 m²"} Label={"Unidades"} /> },
    vagasBicicleta: () => { return <NumberInput Name={"vagasBicicleta"} Placeholder={"0"} Label={"Qtd. vagas de bicicleta"} /> },
    vagasMoto: () => { return <NumberInput Name={"vagasMoto"} Placeholder={"0"} Label={"Qtd. vagas de moto"} /> },
    vagasVeiculo: () => { return <NumberInput Name={"vagasVeiculo"} Placeholder={"0"} Label={"Qtd. vagas de veículo"} /> },
    valorDosServicos: () => { return <NumberInput Name={"valorDosServicos"} Placeholder={"0"} Label={"Valor dos serviços"} /> },
    
    adeAia: () => { return <DropdownInput Name={"adeAia"} ItemsList={listaAdeAia} Label={"ADE/AIA"} Value={"Área"} MinWidth={"207px"} /> },
    bairro: () => { return <DropdownInput Name={"bairro"} ItemsList={listBairrosAju} Label={"Bairro"} Value={"Bairro"} MinWidth={"207px"} OnBlur={AutoCompleteZona} /> },
    bairroObra: () => { return <DropdownInput Name={"bairroObra"} ItemsList={listBairrosAju} Label={"Bairro"} Value={"Bairro"} MinWidth={"207px"} OnBlur={AutoCompleteZona} /> },
    macrozoneamento: () => { return <DropdownInput Name={"macrozoneamento"} ItemsList={listaMacrozonas} Label={"Macrozoneamento"} Value={"Zona"} MinWidth={"207px"} /> },
    servico: () => { return <DropdownInput Name={"servico"} ItemsList={listaServicos} Label={"Servico"} Value={"Tipo"} MinWidth={"207px"} /> },
    tipoUso: () => { return <DropdownInput Name={"tipoUso"} ItemsList={listaTiposUso} Label={"Tipo de uso"} Value={"Tipo"} MinWidth={"207px"} /> },
    zonaProtecao: () => { return <DropdownInput Name={"zonaProtecao"} ItemsList={listaZonaProtecao} Label={"Zona de proteção"} Value={"Zona"} MinWidth={"207px"} /> },
    zonaRuido: () => { return <DropdownInput Name={"zonaRuido"} ItemsList={listaZonaRuido} Label={"Zona de ruído"} Value={"Zona"} MinWidth={"207px"} /> },
    zoneamentoAeroporto: () => { return <DropdownInput Name={"zoneamentoAeroporto"} ItemsList={listaZonaAeronautica} Label={"Zoneamento da aeronáutica"} Value={"Zona"} MinWidth={"207px"} OnChange={autoCompleteAeroporto} /> },
    
    areaNonEdificantiIntPublico: () => { return <CheckboxInput Name={"areaNonEdificantiIntPublico"} Label={"Área non edificanti - Interesse público"} /> },
    areaNonEdificantiSistViario: () => { return <CheckboxInput Name={"areaNonEdificantiSistViario"} Label={"Área non edificanti - Sistema viário"} /> },
    areaSubJudice: () => { return <CheckboxInput Name={"areaSubJudice"} Label={"Área sub júdice"} /> },
    centroHistorico: () => { return <CheckboxInput Name={"centroHistorico"} Label={"Centro histórico"} /> },
    conclusao: () => { return <CheckboxInput Name={"conclusao"} Label={"Deferido"} /> },
    entornoPatrimonio: () => { return <CheckboxInput Name={"entornoPatrimonio"} Label={"Entorno de patrimônio cultural"} /> },
    equipamentosImpacto: () => { return <CheckboxInput Name={"equipamentosImpacto"} Label={"Equipamentos de impacto"} /> },
    imovelConstruido: () => { return <CheckboxInput Name={"imovelConstruido"} Label={"Imóvel construído"} /> },
    interesseCultural: () => { return <CheckboxInput Name={"interesseCultural"} Label={"Interesse cultural"} /> },
    interferenciaMacrodrenagem: () => { return <CheckboxInput Name={"interferenciaMacrodrenagem"} Label={"Possui interferência com o projeto de macrodrenagem"} /> },
    interferenciaSistViario: () => { return <CheckboxInput Name={"interferenciaSistViario"} Label={"Possui interferência com o sistema viário"} /> },
    obraPublica: () => { return <CheckboxInput Name={"obraPublica"} Label={"Obra pública"} /> },
    patrimonioCultural: () => { return <CheckboxInput Name={"patrimonioCultural"} Label={"Patrimônio cultural"} /> },
      
    cep: () => { return <TextWithButtonInput Name={"cep"} Placeholder={"49.000-00"} Label={"CEP"} MaxLength={10} Mask={"99.999-999"} OnClick={AutoCompleteAddressRequerente} ButtonImg={searchImg} /> },
    cepObra: () => { return <TextWithButtonInput Name={"cepObra"} Placeholder={"49.000-00"} Label={"CEP"} MaxLength={10} Mask={"99.999-999"} OnClick={AutoCompleteAddressObra} ButtonImg={searchImg} /> },
        
    dataTermoCompromisso: () => { return <DateInput Name={"dataTermoCompromisso"} Placeholder={"00"} Label={"Data do termo de compromisso"} MaxLength={"25"} /> },
    
    certifico: (tipoDoc, subTipoDoc) => { return <TextAreaInput Name={"certifico"} Label={"Certifico"} Value={certifico[tipoDoc](subTipoDoc)} NumberLines={10} NumberCols={150} /> },
    notas: (tipoDoc) => { return <TextAreaInput Name={"notas"} Label={"Notas"} Value={notasDocumento(tipoDoc)} NumberLines={10} NumberCols={150} /> },
    situacaoInLoco: () => { return <TextAreaInput Name={"situacaoInLoco"} Label={"Situação in loco"} NumberLines={10} NumberCols={150} /> },

    bairrosObraInfra: () => { return <ListInput name={"bairrosObraInfra"} Type={"listText"} label={"Bairros"} maxLength={100} /> },
    areasLotes: (qtd) => { return <ListInput name={"areasLotes"} Type={"listGroupText"} fields={[{"type":"text","name":"nome" + inputGroupNames.AreasLotes,"placeholder":"Área 01","label":"Identificação", "value": "Área"}, {"type":"number","name":"area" + inputGroupNames.AreasLotes,"placeholder":"0.00 m²","label":"Área", "req":true, min: 0.0}]} InitNumberItems={qtd} /> },
    areasVerdes: (qtd) => { return <ListInput name={"areasVerdes"} Type={"listGroupText"} fields={[{"type":"text","name":"nome" + inputGroupNames.AreasVerdes,"placeholder":"Área 01","label":"Identificação", "value": "Área verde"}, {"type":"number","name":"area" + inputGroupNames.AreasVerdes,"placeholder":"0.00 m²","label":"Área", "req":true, min: 0.0}]} InitNumberItems={qtd} /> },
    areasSistViario: (qtd) => { return <ListInput name={"areasSistViario"} Type={"listGroupText"} fields={[{"type":"text","name":"nome" + inputGroupNames.AreasSistViario,"placeholder":"Área 01","label":"Identificação", "value": "Área de via"}, {"type":"number","name":"area" + inputGroupNames.AreasSistViario,"placeholder":"0.00 m²","label":"Área", "req":true, min: 0.0}]} InitNumberItems={qtd} /> },
    dadosObraInfra: () => { return <ListInput name={"dadosObraInfra"} Type={"listGroupText"} fields={[{"type":"text","name":"logradourosObradadosObraInfra","placeholder":"","label":"Logradouros","value":"","req":false,"info":""},{"type": "dropdown", "name": "classViasObradadosObraInfra", "label": "Classificação viária", "value": "Tipo de via", "itemsList": listaClassificacaoVias, "req": false},{"type":"text","name":"caractViasObradadosObraInfra","placeholder":"","label":"Características da via","value":"","req":false,"info":"", "minWidth": "500px"}]} /> },
    loteDescricaoAreaDemarcada: (qtd) => { return <ListInput name={"loteDescricaoAreaDemarcada"} Type={"listGroupText"} fields={[{"type":"text","name":"loteNomeAreaDemarcada","placeholder":"0","label":"Nome do lote","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"textArea","name":"loteDescricaoAreaDemarcada","placeholder":"","label":"Descrição do lote","numberLines":"10","numberCols":"150","req":false,"info":""}]} InitNumberItems={qtd} /> },
    loteDescricaoAreaDesmembrada: (qtd) => { return <ListInput name={"loteDescricaoAreaDesmembrada"} Type={"listGroupText"} fields={[{"type":"text","name":"loteNomeAreaDesmembrada","placeholder":"0","label":"Nome do lote","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"textArea","name":"loteDescricaoAreaDesmembrada","placeholder":"","label":"Descrição do lote","numberLines":"10","numberCols":"150","req":false,"info":""}]} InitNumberItems={qtd} /> },
    loteDescricaoAreaRemembrada: (qtd) => { return <ListInput name={"loteDescricaoAreaRemembrada"} Type={"listGroupText"} fields={[{"type":"text","name":"loteNomeAreaRemembrada","placeholder":"0","label":"Nome do lote","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"textArea","name":"loteDescricaoAreaRemembrada","placeholder":"","label":"Descrição do lote","numberLines":"10","numberCols":"150","req":false,"info":""}]} InitNumberItems={qtd} /> },
    marcosRef: () => { return <ListInput name={"marcosRef"} Type={"[listGroupText]"} fields={[{"type":"text","name":"marcoRefNome","placeholder":"MR-00","label":"Marco Ref.","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"number","name":"marcoRefCota","placeholder":"0,00","label":"Cota","value":"","req":false,"info":"","min":0}]} /> },
    obs: (qtd, tipoDoc, subTipoDoc) => {return <ListInput name={"obs"} Type={"listTextArea"} label={"Observações"} value={obsDocumento(tipoDoc, subTipoDoc)} numberLines={4} numberCols={200} maxLength={100} InitNumberItems={qtd} /> },
    pavimentos: (qtd) => { return <ListInput name={"pavimentos"} Type={"listGroupText"} fields={[{"type":"number","name":"pavimentosQuantidade","placeholder":"0","label":"Quantidade","value":"","req":false,"info":"","min":0},{"type":"dropdown","name":"pavimentosClassificacao","label":"Classificação","value":"Tipo","itemsList":["Térreo","Superior"],"req":false},{"type":"number","name":"pavimentosAreaConstruida","placeholder":"0.00 m²","label":"Área construída","value":"","req":false,"info":"","min":1},{"type":"text","name":"pavimentosDetAreaConstruida","placeholder":"(0.0 m x 0.0m)","label":"Detalhes área","value":"","req":false,"info":""},{"type":"textArea","name":"pavimentosDescricaoAmbientes","placeholder":"Sala, 2 quartos...","label":"Descrição dos ambientes","numberLines":"2","numberCols":"100","req":false,"info":""}]} InitNumberItems={qtd} /> },
    registrosMatriculas: (qtd) => { return <ListInput name={"registrosMatriculas"} Type={"listGroupText"} fields={[{"type":"text","name":"numeroregistrosMatriculas","placeholder":"0","label":"N° registro / matrícula","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"textArea","name":"descricaoregistrosMatriculas","placeholder":"","label":"Descrição do registro / matrícula","numberLines":"10","numberCols":"150","req":false,"info":""}]} InitNumberItems={qtd} /> },
    respTec: (qtd) => { return <ListInput name={"respTec"} Type={"listGroupText"} fields={[{"type": "dropdown", "name": "tipoRespTec", "label": "Tipo", "value": "Responsabilidade", "itemsList": listaRespTecTipo, "req": false}, {"type": "text", "name": "nomeRespTec", "placeholder": "Fulano da Silva", "label": "Nome", "value": "", "req": false, "info": "", "maxLength": "50", "mask": null, "minWidth": "425px"},{"type": "text", "name": "crea_cauRespTec", "placeholder": "", "label": "Registro", "value": "", "req": false, "info": "", "maxLength": "25", "mask": null}]} InitNumberItems={qtd} /> },
    servicosASeremRealizados: () => { return <ListInput name={"servicosASeremRealizados"} Type={"listTextArea"} label={"Serviço"} numberLines={10} numberCols={150} maxLength={100} /> },
    unidadesHabitacionais: (qtd) => { return <ListInput name={"unidadesHabitacionais"} Type={"listGroupText"} fields={[{"type":"text","name":"tipounidadesHabitacionais","placeholder":"","label":"Tipo de unid. hab.","value":"","req":false,"info":"","maxLength":"25","mask":null},{"type":"number","name":"qtdunidadesHabitacionais","placeholder":"0","label":"Quantidade de unid. hab.","value":"","req":false,"info":"","min":0},{"type":"number","name":"areaUtilunidadesHabitacionais","placeholder":"0","label":"Área útil das unid. hab.","value":"","req":false,"info":"","min":0},{"type":"number","name":"areaConstruidaunidadesHabitacionais","placeholder":"0","label":"Área construída da unid. hab.","value":"","req":false,"info":"","min":0},{"type":"number","name":"areaPrivativaunidadesHabitacionais","placeholder":"0","label":"Área privativa da unid. hab.","value":"","req":false,"info":"","min":0}]} InitNumberItems={qtd} /> }
    
}